import React, { Component } from "react";
import { Route, Switch, Link } from "react-router-dom";
import {connect} from 'react-redux';
import Box from "../../components/Box";
import Chart from "../../components/Chart";
import ListData from "../../components/ListData";
import TableData from "../../components/TableData";
import DatePicker from "../../components/DatePicker";
import MultiSelect from "../../components/MultiSelect";
import LoadingModal from "../../components/LoadingModal";
import "./styles.css";

import {
  Menu,
  Container,
  Dropdown,
  Header,
  Grid,
  Sidebar,
  Segment,
  Button,
  Divider,
  Label,
  Table,
  Tab,
  Icon
} from "semantic-ui-react";
import moment from "moment";

const options = [
  {
    value: "all",
    text: "Location",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300
    }
  },
  {
    value: "locone",
    text: "Location One",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300
    }
  },
  {
    value: "loctwo",
    text: "Location Two",
    style: {
      backgroundColor: "none",
      color: "rgb(102, 104, 116)",
      fontSize: 14,
      fontWeight: 300
    }
  }
];

class Inventory extends Component {
  onLogout() {
    this.props.authOnLogout();
  }
  constructor(props) {
    super(props);

    this.state = { value: "all" };
  }

  reset() {
    this.setState({ value: undefined });
  }

  setProducts() {
    this.setState({ value: "products" });
  }

  setValue(e, data) {
    this.setState({ value: data.value });
  }

  render() {
    const { value } = this.state;
    const {
      pos_chart,
      grns_chart,
      invoices_chart,
      locations,
      inventory_value,
      gmroi,
      sale_grn_inventory,
      turns,dusty_inventory,
      low_stock,low_stock_items,
      dead_stock_items,
      inventory_by_categories,
      inventory_by_sub_categories,
      inventory_by_top_selling,
      inventory_by_low_selling,
      compile_time
    } = this.props 
    const barChartTemplate = {
      chart: {
        backgroundColor: "none",
        marginLeft: 45,
        height: 382,
        fontFamily: "Roboto",
        fontWeight: 400,
        spacingTop: 10,
        type: "line",
        style: {
          paddingBottom: 10,
          fontSize: 16
        }
      },
      title: {
        useHTML: true,
        style: {
          color: "#414042",
          fontSize: 16,
          fontWeight: 400,
          fontFamily: "Roboto"
        },
        text: null,
        align: "left",
        x: -5,
        y: 5
      },
      xAxis: {
        categories: [],
        labels: {
          style: {
            fontSize: "8px"
          }
        }
      },
      yAxis: [
        {
          title: {
            text: null
          }
        }
      ],
      legend: {
        itemStyle: {
          fontWeight: "400",
          fontSize: "13px",
          fontFamily: "Roboto",
          color: "#414042"
        }
      },
      labels: {
        items: []
      },
      series: [],
      credits: {
        enabled: false
      }
    };
    const lineChartTemplate= {

      title: {
          text: 'Solar Employment Growth by Sector, 2010-2016'
      },
  
      subtitle: {
          text: 'Source: thesolarfoundation.com'
      },
  
      yAxis: {
          title: {
              text: 'Number of Employees'
          }
      },
      legend: {
          layout: 'vertical',
          align: 'right',
          verticalAlign: 'middle'
      },
  
      plotOptions: {
          series: {
              label: {
                  connectorAllowed: false
              },
              pointStart: 2010
          }
      },
  
      series: [
        {
          name: 'Installation',
          data: [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175],
          color: {
            "linearGradient": {
              "x2": 0,
              "y1": 0,
              "x1": 0,
              "y2": 1
            },
            "stops": [
              [
                0,
                "#fdc2a4"
              ],
              [
                1,
                "#f895cc"
              ]
            ]
          },
          
        }, {
            name: 'Manufacturing',
            data: [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434]
        }
      ],
  
      responsive: {
          rules: [{
              condition: {
                  maxWidth: 500
              },
              chartOptions: {
                  legend: {
                      layout: 'horizontal',
                      align: 'center',
                      verticalAlign: 'bottom'
                  }
              }
          }]
      }
  
    }
    const lineChartTemplate2 = {
      "title": {
          "text": ''
      },
      "subtitle": {
          "text": 'Source thesolarfoundation.com'
      },
      "yAxis": {
          "title": {
              "text": 'Number of Employees'
          }
      },
      "legend": {
          "layout": 'vertical',
          "align": 'right',
          "verticalAlign": 'middle'
      },
      "plotOptions": {
          "series": {
              "label": {
                  "connectorAllowed": false
              },
              "pointStart": 2010
          }
      },
      "series": [
        {
          "name": 'Sales',
          // "yAxis": 1,
         "color": {
           "linearGradient": {
             "x2": 0,
             "y1": 0,
             "x1": 0,
             "y2": 1
           },
           "stops": [
             [
               0,
               "#fee332"
             ],
             [
               1,
               "#fead41"
             ]
           ]
         },
        "data": [43934, 52503, 57177, 69658, 97031, 119931, 137133, 154175],
        // "data": [],
        // "showInLegend": true
        },
        {
          "name": 'GRNS',
          // "yAxis": 1,
         "color": {
           "linearGradient": {
             "x2": 0,
             "y1": 0,
             "x1": 0,
             "y2": 1
           },
           "stops": [
             [
               0,
               "#fee332"
             ],
             [
               1,
               "#fead41"
             ]
           ]
         },
         "data": [24916, 24064, 29742, 29851, 32490, 30282, 38121, 40434],
        //  "data": [],
        // "showInLegend": true
        },
        {
          "name": 'Inventory Value',
          // "yAxis": 1,
         "color": {
           "linearGradient": {
             "x2": 0,
             "y1": 0,
             "x1": 0,
             "y2": 1
           },
           "stops": [
             [
               0,
               "#fee332"
             ],
             [
               1,
               "#fead41"
             ]
           ]
         },
        // "data": [],
        "data": [24916, 52503, 29742, 69658, 32490, 119931, 38121, 154175],        
        // "showInLegend": true
        }
      ],
      "responsive": {
          "rules": [{
              "condition": {
                  "maxWidth": 500
              },
              "chartOptions": {
                  "legend": {
                      "layout": 'horizontal',
                      "align": 'center',
                      "verticalAlign": 'bottom'
                  }
              }
          }]
      }
    }

    const lineChartBack={
      "series": [
        {
          "name": "Sales",
          "yAxis": 1,
          "color": {
            "linearGradient": {
              "x2": 0,
              "y1": 0,
              "x1": 0,
              "y2": 1
            },
            "stops": [
              [
                0,
                "#fee332"
              ],
              [
                1,
                "#fead41"
              ]
            ]
          },
          "type": "column",
          "data": [],
          "showInLegend": true
        },
        {
          "name": "GRNS",
          "yAxis": 0,
          "color": {
            "linearGradient": {
              "x2": 0,
              "y1": 0,
              "x1": 0,
              "y2": 1
            },
            "stops": [
              [
                0,
                "#6fddb6"
              ],
              [
                1,
                "#52baef"
              ]
            ]
          },
          "type": "column",
          "data": [],
          "showInLegend": true
        },
        {
          "name": "Inventory Value",
          "yAxis": 0,
          "color": {
            "linearGradient": {
              "x2": 0,
              "y1": 0,
              "x1": 0,
              "y2": 1
            },
            "stops": [
              [
                0,
                "#6fddb6"
              ],
              [
                1,
                "#52baef"
              ]
            ]
          },
          "type": "column",
          "data": [],
          "showInLegend": true
        }
      ],
      "categories": [
        "Mon",
        "Tue",
        "Wed",
        "Thu",
        "Fri",
        "Sat",
        "Sun"
      ]
    }
    const secondary_yAxis = {
      gridLineWidth: 1,
      title: {
        text: null
      },
      opposite: true
    };
    const locationsChart=locations.map((location)=>{
      const locationChart = JSON.parse(JSON.stringify(barChartTemplate));
      locationChart["xAxis"]["categories"] = location["categories"];
      locationChart["series"] = location["series"];
      locationChart["header"] = location["header"];
      if (location["yAxis"]){
        locationChart["yAxis"] = location["yAxis"];
      }
      
      return locationChart;
    });
    // Static Charts starts here
    const posChart = JSON.parse(JSON.stringify(barChartTemplate));
    posChart["xAxis"]["categories"] = pos_chart["categories"];
    posChart["series"] = pos_chart["series"];
    if (pos_chart["yAxis"]){
      posChart["yAxis"]=pos_chart["yAxis"];
    }
    else{
      posChart["yAxis"].push(secondary_yAxis);
    }
    
    
    const grnsChart = JSON.parse(JSON.stringify(barChartTemplate));
    grnsChart["xAxis"]["categories"] = grns_chart["categories"];
    grnsChart["series"] = grns_chart["series"];
    if (grns_chart["yAxis"]){
      grnsChart["yAxis"]=grns_chart["yAxis"];
    }
    else{
      grnsChart["yAxis"].push(secondary_yAxis);
    }
    

    const invoicesChart = JSON.parse(JSON.stringify(barChartTemplate));
    invoicesChart["xAxis"]["categories"] = invoices_chart["categories"];
    invoicesChart["series"] = invoices_chart["series"];
    if (invoices_chart["yAxis"]){
      invoicesChart["yAxis"]=invoices_chart["yAxis"];
    }
    else{
      invoicesChart["yAxis"].push(secondary_yAxis);
    }
    // Static Charts ends here
    
    // top_items_by_sales.header = "Top Selling Menu Products";
    // lowest_items_by_sales.header = "Low Selling Menu Products";

    const formatNum = num => {
      return num.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ",");
    };
    // let time = compile_time ? new Date(compile_time) : '';
    return (
      <div>
        <Grid.Row style={{ float: "right", marginRight:15  }}>
          {/* {time ? <div className='lastUpdatedText'
          >
            Last Updated: {time.getFullYear() + "-" + (time.getMonth() + 1) + "-" + time.getDate() + " " + time.getHours() + ":" + time.getMinutes() + ":" + time.getSeconds()} </div> : null} */}
          <Grid.Column>
            <MultiSelect />
          </Grid.Column>
          <Grid.Column>
            <div style={styles.datePicker}>
              <DatePicker />
            </div>
          </Grid.Column>
        </Grid.Row>
        <div className="innersection">
          <Header style={styles.mainHeadig} as="h3">
            INVENTORY INSIGHTS
          </Header>

          <Grid columns={5}>
            <Box componentData={inventory_value} />
            <Box componentData={gmroi} />
            <Box componentData={turns} />
            <Box componentData={dusty_inventory} />
            <Box componentData={low_stock} />
          </Grid>

          <Header style={styles.mainHeadig} as="h3">
            INVENTORY BY LOCATION 
          </Header>

          <Grid columns={3}>
            {locationsChart.map((chart,index)=>{
              return (
                <Chart key={index} title={chart['header']} data={chart} />
              );
            })}
            {/* <Chart title="MAIN STORE" data={inventoryValueChart} />
            <Chart title="ZAMZAMA" data={inventoryValueChart} />
            <Chart title="DMC" data={inventoryValueChart} /> */}
          </Grid>


          {/* <Grid columns={1}>
            <Chart data={sale_grn_inventory} />
          </Grid> */}

            
          <Grid columns={3}>
            <Chart title="POS" data={posChart} />
            <Chart title="GRNS" data={grnsChart} />
            <Chart title="INVOICES" data={invoicesChart} />
          </Grid>

          {/* <Grid columns={2}>
            <TableData
              style={{ marginLeft: -25 }}
              currency="Rs."
              usePropsHeader={true}
              componentData={low_stock_items}
            />
            <TableData currency="Rs." 
              componentData={dead_stock_items}
              usePropsHeader={true}            
            />
          </Grid> */}


          <Header style={styles.mainHeadig} as="h3">
            INVENTORY ANALYSIS 
          </Header>


          <Grid columns={2}>
            <TableData currency="Rs." usePropsHeader={true} componentData={inventory_by_categories} />
            <TableData currency="Rs." usePropsHeader={true} componentData={inventory_by_sub_categories} />
          </Grid>

          <Grid columns={2}>
            <TableData currency="Rs." usePropsHeader={true} componentData={inventory_by_top_selling} />
            <TableData currency="Rs." usePropsHeader={true} componentData={inventory_by_low_selling} />
          </Grid>
          
        </div>
      </div>
    );
  }
}

const styles = {
  headingText: {
    fontSize: 16,
    color: "#666874",
    marginTop: 20,
    marginBottom: 15,
    paddingBottom: 18,
    paddingLeft: 5,
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto",
    textShadow: "none",
    borderStyle: "solid",
    borderBottomWidth: 1,
    borderBottomColor: "#c1c1c5"
  },
  comingSoon: {
    backgroundColor: "#59d345",
    color: "#fff",
    fontFamily: "Roboto",
    paddingTop: 20,
    paddingBottom: 20,
    paddingLeft: 15,
    paddingRight: 15
  },
  dropDown: {
    fontFamily: "Roboto",
    borderRadius: 20,
    color: "rgb(102, 104, 116)",
    marginRight: 50,
    position: "relative",
    top: 52,
    backgroundColor: "transparent",
    fontSize: 14,
    fontWeight: 300
  },
  customClass: {
    backgroundColor: "transparent",
    color: "rgb(102, 104, 116)",
    fontSize: 14,
    fontWeight: 300
  },
  topHeader: {
    backgroundColor: "#652d92",
    color: "white"
  },
  mainHeadig: {
    marginTop: 30,
    fontWeight: 400,
    fontFamily: "Roboto",
    color: "#666874",
    paddingTop:40
  },
  title: {
    padding: 10,
    fontSize: 22
  },
  sideBar: {
    top: 45,
    backgroundColor: "#2c2435"
  },
  datePicker: {
    paddingTop: 20,
    paddingRight: 20,
    fontFamily: "Roboto",
    color: "#666874",
    fontWeight: 400
  },

  mainTable: {
    borderWidth: 0,
    paddingLeft: 15,
    paddingRight: 15,
    backgroundColor: "transparent"
  },
  tablerow: {
    textAlign: "center",
    fontFamily: "Roboto",
    backgroundColor: "none"
  },
  hederCell: {
    backgroundColor: "#ECF3FA",
    color: "#999",
    fontSize: 14,
    fontWeight: 300,
    paddingTop: 15,
    paddingBottom: 15,
    borderColor: "#c1c1c5",
    borderWidth: 0.7,
    borderRadius: 0
  },
  tableCellfirst: {
    backgroundColor: "#F9F9FE",
    color: "#999",
    fontSize: 14,
    paddingTop: 15,
    paddingBottom: 15,
    borderTopWidth: 0.5,
    borderTopColor: "#C9C9C9"
  },
  tableCell: {
    backgroundColor: "#F9F9FE",
    color: "#313131",
    fontSize: 14,
    paddingTop: 25,
    paddingBottom: 25,
    borderTopWidth: 0.5,
    borderTopColor: "#C9C9C9"
  },
  headerRow: {
    textAlign: "center",
    fontFamily: "Roboto"
  },
  heading: {
    fontSize: 16,
    color: "rgb(102, 104, 116)",
    paddingBottom: 10,
    paddingLeft: 15,
    paddingTop: 5,
    fontWeight: 400,
    textTransform: "uppercase",
    fontFamily: "Roboto"
  }
};

export default connect(state=>{
  return {
    ...state.inventory
  }
})(Inventory);



// WEBPACK FOOTER //
// ./src/components/TabSales/inventory.js